import FormHelpers from '@assets/js/form-helpers.js';

export const passwordValidationMixin = {
  data() {
    return {
      hasPasswordLetter: false,
      hasPasswordNumber: false,
      hasPasswordSpecialChar: false,
      hasPasswordLength: false,
      passwordTooLong: false,
      spacesInPassword: false,
      showPasswordValidationText: false,
    }
  },
  methods: {
    onPasswordChanged(e) {
      var field = e.currentTarget;
      this.updatePasswordDots(field.value);

      if (/\s/.test(field.value)) {
        this.spacesInPassword = true;
      } else {
        this.spacesInPassword = false;
      }

      if (field.classList.contains('untouched')) {
        return;
      }

      // Handle repeat password validation
      const repeatPasswordField = this.getRepeatPasswordField();
      if (field.name == 'password' && repeatPasswordField && repeatPasswordField.value) {
        this.onFieldUpdated(repeatPasswordField);
      }
    },

    updatePasswordDots(pw) {
      this.hasPasswordLetter = FormHelpers.stringHasLetters(pw);
      this.hasPasswordNumber = FormHelpers.stringHasNumber(pw);
      this.hasPasswordSpecialChar = FormHelpers.stringHasPasswordSpecialChar(pw);
      this.hasPasswordLength = FormHelpers.validPasswordLength(pw);
      this.passwordTooLong = !FormHelpers.validPasswordMaxLength(pw);
    },

    isPasswordValid() {
      return this.hasPasswordLetter &&
             this.hasPasswordNumber &&
             this.hasPasswordSpecialChar &&
             this.hasPasswordLength &&
             !this.passwordTooLong;
    },

    // Abstract method to be implemented by each component
    getRepeatPasswordField() {
      // Each form implements this to return their repeat password field
      return null;
    }
  }
}

export default passwordValidationMixin;
